import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Commercial from "./pages/Commercial";
import Residential from "./pages/Residential";
import BookCleaning from "./pages/BookCleaning";
import Employment from "./pages/Employment";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Privacy, Terms } from "./pages/Legal";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-primary" size={36} /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

const Public = (C) => <Layout><C /></Layout>;

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={Public(Home)} />
          <Route path="/commercial" element={Public(Commercial)} />
          <Route path="/residential" element={Public(Residential)} />
          <Route path="/book" element={Public(BookCleaning)} />
          <Route path="/employment" element={Public(Employment)} />
          <Route path="/about" element={Public(About)} />
          <Route path="/contact" element={Public(Contact)} />
          <Route path="/privacy" element={Public(Privacy)} />
          <Route path="/terms" element={Public(Terms)} />
          <Route path="/payment/success" element={Public(PaymentSuccess)} />
          <Route path="/payment/cancel" element={Public(PaymentCancel)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
